module.exports = __webpack_public_path__ + "static/media/x.6e9cdc0b.png";